/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.date.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import "@/api";
import Clocker from "vux/src/components/clocker/index.vue";
import CompRegDone from './CompRegDone';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { MUTATION_APPT_DETAIL } from '@/store/mutation_types';
export default {
  props: {
    obj: {
      type: Object
    },
    index: {
      type: Number
    },
    type: {
      type: String
    }
  },
  data: function data() {
    return {};
  },
  components: {
    Clocker: Clocker,
    CompRegDone: CompRegDone
  },
  created: function created() {},
  mounted: function mounted() {},
  watch: {},
  computed: {
    payEndTime: function payEndTime() {
      if (this.type != 'current') {
        return '';
      }

      var obj = this.obj;
      var leftTime = parseInt(15 * 60 - obj.paySurplus);

      if (leftTime < 0) {
        obj.payEndTime = 0;
      } else {
        var payEndTime = new Date().getTime() + leftTime * 1000;
        payEndTime = Utils.gettimeFormat("yyyy-MM-dd hh:mm:ss", payEndTime);
        return payEndTime;
      }

      return '';
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setApptDetail: 'MUTATION_APPT_DETAIL'
  })), {}, {
    goApptDetail: function goApptDetail(obj, index) {
      console.log(obj);
      var recordId = obj.recordId,
          apptOrderCode = obj.apptOrderCode;
      this.$router.push({
        name: 'ApptRegMyApptDetail',
        query: {
          recordId: recordId,
          apptOrderCode: apptOrderCode
        }
      });
    }
  })
};